// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__Jsr3x","box":"WorkspacesBox_box__246ST","node":"WorkspacesBox_node__3SN-h"};